import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import { completeLogin, restoreSession, authConfigured, isAuthed, isSignedOut, login } from './auth/cognito';
import { SignedOut } from './auth/SignedOut';
import { useStore } from './store';

// Handle the Hosted UI redirect before rendering, otherwise restore an existing session.
async function boot() {
  const onCallback = window.location.pathname.startsWith('/auth/callback');
  if (onCallback) {
    await completeLogin().catch(() => false);
  } else {
    restoreSession();
  }
  // The store was created at import time (before the above resolved the token); refresh
  // identity now so the signed-in user — not the demo persona — shows on first render.
  useStore.getState().syncAuth();

  // An explicit logout must not immediately restart corporate SSO on the return redirect.
  if (authConfigured && isSignedOut() && !isAuthed()) {
    createRoot(document.getElementById('root')!).render(<SignedOut />);
    return;
  }

  // Auth-gated build (Cognito configured): present the corporate sign-in straight away on
  // landing instead of making the user find it. Federation means this lands on the Hosted
  // UI's "Sign in with your corporate ID". Skipped on the callback path and once signed in.
  if (authConfigured && !isAuthed() && !onCallback) {
    await login().catch(() => {});
    return; // navigating to the Hosted UI; nothing to render
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
}

void boot();
